module.exports = __webpack_public_path__ + "static/media/26_tn.10ca77ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/26_tn.jpg
// module id = 514
// module chunks = 0